'use client'

import ContentWrapper from '@/components/ui/ContentWrapper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { ReactNode } from 'react'

// Die Service-Liste kommt als Server-Komponente per Slot von der Page herein
// (CapabilitiesList ist server-rendered, dieser Wrapper bleibt Client)
const HomeOurCapabilities = ({ children }: { children?: ReactNode }) => {
  const t = useTranslations('capabilities')

  return (
    <ContentWrapper tag="section" className="mt-24 lg:mt-32 lg:gap-x-8 relative">
      <div className="absolute w-dvw -mx-8 lg:ml-[calc(50%-50dvw)] lg:mx-auto hidden lg:flex -top-24 lg:-top-32 h-[calc(100%+160px)] lg:h-[calc(100%+192px)] overflow-hidden -z-1 ">
        <Image src="/images/backgrounds/globe.png" width={2000} height={1884} alt="transparent globe" className="opacity-10 translate-x-1/3 select-none w-full h-full object-contain" />
      </div>
      <h2 className="font-medium text-2xl lg:text-[32px] leading-6 col-span-full">{t('title')}</h2>
      {children}
    </ContentWrapper>
  )
}

export default HomeOurCapabilities
